// extracted by mini-css-extract-plugin
module.exports = {"container":"Jg","timeTop":"Kg","timeCountdown":"Lg","cta":"Mg","disabled":"Ng","product":"Og"};